{
    "badge__not_released_title": "Noch nicht in der Warenwirtschaft freigegeben.",
    "badge__not_released_body": "Klicke auf Optionen um den Vorgang aus Plato heraus freizugeben."
}
